import { ErrorHandler, Injectable } from '@angular/core';
import { AppConfigService } from '../services/app-config.service';
import { ApiException } from '../services/api-services';

@Injectable()
export class BrowserErrorHandler implements ErrorHandler {
  private apiKey: string = '';

  constructor(private readonly configService: AppConfigService) {
    this.configService = configService;
  }

  handleError(error: any): void {
    if (error instanceof ApiException) {
      return;
    }

    console.log(error);
    
    this.checkAndSetupRaygun();

    if (this.apiKey) {
      this.sendErrorToRaygun(error);
    }

    // throw error;
  }

  private checkAndSetupRaygun(): void {
    if (!this.apiKey) {
      const config = this.configService.getConfig();

      if (config?.raygunApiKey) {
        this.apiKey = config.raygunApiKey;
      }
    }
  }

  private sendErrorToRaygun(error: string): void {
    // TODO: This throws an exception even on server!
    (window as any).rg4js('send', {
      error: error,
    });
  }
}
